import { isArray } from 'lodash';
import { IStoreState } from 'src/store';
import * as acBase from 'src/store/states/GenericActionCreator';
import { ActionFramework } from './Framework';
import { ViewMode, CustMode, Vehicles } from 'src/enums';
import { IView } from 'Framework';
import { ThunkAction } from 'redux-thunk';
import { IFrameworkState } from '..';
import { NewVehicle, TokenKeys, IdmUuids } from 'src/models';
import { blankToken } from 'src/models/Framework/TestFramework';
import { AddNewVehicle } from '../NewVehicle/NewVehicleSlice';
import { AxiosError } from 'axios';

type FrameworkThunk<T = void> = ThunkAction<T, IStoreState, never, ActionFramework>;

/** Attempts to log the user in. */
export function login(): FrameworkThunk<Promise<boolean>> {
    return async (dispatch, _getState) => {
        dispatch({ type: 'Framework/REQUEST_LOGIN' });
        // const loggedIn = await isLoggedIn();

        dispatch(logout());

        return await false;
    };
}

/** Logout the current user. */
export function logout(): FrameworkThunk {
    return (dispatch, _getState) => {
        // Reset the states.
        dispatch({ type: 'LOGOUT' });
    };
}

/**
 * Update the theme for the current user.
 * @param theme
 */
export function updateTheme(theme: string) {
    return (dispatch: (action: ActionFramework) => void, getState: () => IStoreState) => {
        // Change the theme only if different.
        if (getState().Framework.theme !== theme) {
            // Update the UI theme.
            dispatch({ type: 'Framework/SET_THEME', payload: theme });
        }
    };
}

/**
 * Update the Service side token for the current user.
 * @param theme
 */
export function updateUserServerToken(): FrameworkThunk<Promise<void>> {
    return async (dispatch) => {
        await acBase.digiDataServiceCall(null, 'UpdateUserServerToken', dispatch, 'Specs');
    };
}

export function ERARunArea(): FrameworkThunk {
    return async (dispatch) => {
        const program = 'PRGBRNC0';
        const reqData = { '7': 'SL', '113': '01', '115': 'servc', '120': '01' };

        const response = await acBase.eraWebServiceCall(program, 'GetRunArea', reqData);

        // If the response is undefined then do not attempt to convert
        const rtn = !!response;

        dispatch({ type: 'Framework/SET_RUN_AREA', payload: rtn });
    };
}

/**
 * Clear session filters for the given search component.
 * @param screen id
 */

let nextTimeoutID: number | undefined = undefined;
let lastEventTime: number = 0;

/**
 *  This function is to reset the time out timers for the user.
 */
export function resetTimer(): FrameworkThunk {
    return (dispatch, getState) => {
        // Track the changes every 30+ seconds. so to not spam the Server
        if ((new Date().valueOf() - lastEventTime) < 30000) {
            return;
        }
        lastEventTime = new Date().valueOf();

        // default is 120 minutes
        let timeOutMin: number = 120;

        // THis is to help keep it more insync with the server
        timeOutMin = timeOutMin - 1;
        // convert minutes into miliseconds
        timeOutMin = timeOutMin * 60000;
        window.clearTimeout(nextTimeoutID);
        dispatch(updateUserServerToken());

        // This is the timeout loop. and inside is the log out loop
        nextTimeoutID = window.setTimeout(() => {
            dispatch({ type: 'Framework/TRIGGER_USERACTIVE', payload: false });
            let curTimeSec: number = new Date().getSeconds();
            // This Interval loop is used to keep the log out alert synced with
            // The amount of seconds left.
            const interVal = window.setInterval(() => {
                // Break out if the user is Back or the timer has hit zero.
                if (getState().Framework.userActiveFlag || getState().Framework.timeoutTimer < 1) {
                    window.clearInterval(interVal);
                }
                if (getState().Framework.timeoutTimer < 1) {
                    dispatch(logout());
                    // Do not trigger within the same second
                } else if (curTimeSec !== new Date().getSeconds()) {
                    curTimeSec = new Date().getSeconds();
                    dispatch({ type: 'Framework/SET_AUTOLOGOFFTIME', payload: (getState().Framework.timeoutTimer - 1) });
                }
                // trigger every .5 seconds
            }, 500);
        }, timeOutMin);
    };
}




export function pushToMainPane(inputView: IView): FrameworkThunk {
    return (dispatch) => {
        const view: IView = { ...inputView };

        if (view.viewId === 'AddVehicle') {
            const newVehicleInfo: NewVehicle = {
                vin: '',
                vinValid: false,
                makeCode: '',
                make: '',
                model: '',
                year: '',
                trim: '',
                color: 'default',
                estMileage: '',
                makeId: '',
                modelId: '',
            };
            AddNewVehicle(newVehicleInfo);
        }
        // Check to see if this component is already loaded.
        // const index = getState().Framework.mainPaneViewOrder.findIndex((x: IView) => x.viewId === view.viewId);
        // Make sure we are in Landing Page ViewMode.
        // if (getState().Framework.viewMode !== ViewMode.LandingPage) {
        // TODO(harrisj1): This doesn't appear to be a valid action, what is it supposed to do?
        // dispatch({ type: 'Framework/Set_ViewMode', payload: ViewMode.LandingPage } as unknown as ActionFramework);
        // }

        // Add the component if it is not there.
        // if (index < 0) {
        dispatch({
            type: 'Framework/PUSH_TO_MAIN_PANE',
            payload: view,
        });
        // }
    };
}

/** Called to remove a component from the Main ViewPane */
export function popFromMainPane(id: string | string[]): FrameworkThunk {
    return (dispatch) => {
        const ids = isArray(id) ? id : [id];
        dispatch({ type: 'Framework/POP_FROM_MAIN_PANE', payload: ids });
    };
}

/** Called to remove all components from the Main ViewPane */
export function clearMainPanes(): FrameworkThunk {
    return (dispatch) => {
        dispatch({ type: 'Framework/CLEAR_MAIN_PANES' });
    };
}

/** Called to add a component to the Left View Pane */
export function pushToLeftPane(inputView: IView): FrameworkThunk {
    return (dispatch) => {
        const view: IView = { ...inputView };
        // Check to see if this component is already loaded.
        // const index = getState().Framework.mainPaneViewOrder.findIndex((x: IView) => x.viewId === view.viewId);
        // Make sure we are in Landing Page ViewMode.
        // if (getState().Framework.viewMode !== ViewMode.LandingPage) {
        // TODO(harrisj1): This doesn't appear to be a valid action, what is it supposed to do?
        // dispatch({ type: 'Framework/Set_ViewMode', payload: ViewMode.LandingPage } as unknown as ActionFramework);
        // }

        // Add the component if it is not there.
        // if (index < 0) {
        dispatch({
            type: 'Framework/PUSH_TO_LEFT_PANE',
            payload: view,
        });
        // }
    };
}

/** Called to remove a component from the Left ViewPane */
export function popFromLeftPane(id: string | string[]): FrameworkThunk {
    return (dispatch) => {
        const ids = isArray(id) ? id : [id];
        dispatch({ type: 'Framework/POP_FROM_LEFT_PANE', payload: ids });
    };
}

/** Called to remove all components from the Left ViewPane */
export function clearLeftPanes(): FrameworkThunk {
    return (dispatch) => {
        dispatch({ type: 'Framework/CLEAR_LEFT_PANES' });
    };
}

export function acSetViewMode(viewMode: ViewMode): FrameworkThunk {
    return (dispatch, _getState) => {
        dispatch({ type: 'Framework/Set_ViewMode', payload: viewMode } as unknown as ActionFramework);
    };
}

export function acSetCustMode(custMode: CustMode): FrameworkThunk {
    return (dispatch, _getState) => {
        dispatch({ type: 'Framework/Set_CustMode', payload: custMode } as unknown as ActionFramework);
    };
}

export function setLocale(inp: string): FrameworkThunk {
    return (dispatch, _getState) => {
        dispatch({ type: 'Framework/SET_LOCALE', payload: inp} as unknown as ActionFramework);
    };
}

export function getTokenData(inp: string): FrameworkThunk | ((dispatch: any, getState: () => IStoreState) => Promise<void>) {
    // Determine if we are loading CV
    const urlString = window.location.href;
    const app = new URLSearchParams(urlString).getAll('app');
    const isConnectedVehicle = app[0] === 'CV' ? true : false;

    return async (dispatch) => {
        if (inp) {
            const reqData = {
                keyToken: inp,
                callingProgram: 'SVP',
            };
            let response = await acBase.eraWebServiceCall('SVPController', 'ReadToken', reqData, '', '', 'acctg');
            if (response && ((response as AxiosError).isAxiosError || (!isConnectedVehicle &&
                response.specProfile === undefined))) {
                response = {
                    store: '',
                    branch: '',
                    specProfile: '',
                    loadNameId: '',
                    loadVin: '',
                    loadRO: '',
                    loadAppt: '',
                    loadOpCode: '',
                    resetPassFlag: '',
                    serviceDocsFlag: '',
                    goToLoginFlag: '',
                    tokenErrMsg: '1000',
                    osdWebViewFlag: '',
                    portalLaunched: '',
                    osdLaunched: '',
                    eApprovalLaunched: '',
                    smsLaunched: '',
                    miscdec: '',
                    toyotaMCLaunched: '',
                    lexusMCLaunched: '',
                    toyotaSSC2Launched: '',
                    lexusSSC2Launched: '',
                    toyotaCustSearchLaunched: '',
                    lexusCustSearchLaunched: '',
                    gmossVersion: '',
                    toyotaTDMCLaunched: '',
                    lexusTDMCLaunched: '',
                    toyotaTDSSC2Launched: '',
                    lexusTDSSC2Launched: '',
                    toyotaTDCSLaunched: '',
                    lexusTdCSLaunched: '',
                };
                dispatch({
                    type: 'Framework/ERA_ERROR',
                    payload: inp,
                });
            } else {
                dispatch({
                    type: 'Framework/GET_TOKEN_DATA',
                    payload: response as IFrameworkState,
                });
            }
        } else {
            const response = {
                store: '',
                branch: '',
                specProfile: '',
                loadNameId: '',
                loadVin: '',
                loadRO: '',
                loadAppt: '',
                loadOpCode: '',
                resetPassFlag: '',
                serviceDocsFlag: '',
                goToLoginFlag: '',
                tokenErrMsg: '1000',
                osdWebViewFlag: '',
                portalLaunched: '',
                osdLaunched: '',
                eApprovalLaunched: '',
                smsLaunched: '',
                miscdec: '',
                toyotaMCLaunched: '',
                lexusMCLaunched: '',
                toyotaSSC2Launched: '',
                lexusSSC2Launched: '',
                toyotaCustSearchLaunched: '',
                lexusCustSearchLaunched: '',
                gmossVersion: '',
                toyotaTDMCLaunched: '',
                lexusTDMCLaunched: '',
                toyotaTDSSC2Launched: '',
                lexusTDSSC2Launched: '',
                toyotaTDCSLaunched: '',
                lexusTDCSLaunched: '',
            };
            // if (localURL) {
            //     response = {
            //         store: '01',
            //         branch: '01',
            //         specProfile: '10',
            //         loadNameId: '',
            //         loadVin: '',
            //         loadRO: '',
            //         loadAppt: '',
            //         loadOpCode: '',
            //         resetPassFlag: '',
            //         serviceDocsFlag: '',
            //         goToLoginFlag: '',
            //         tokenErrMsg: '',
            //     };
            // }
            dispatch({
                type: 'Framework/GET_TOKEN_DATA',
                payload: response as IFrameworkState,
            });
        }
    };
}

export function setPreviewFlag(inp: string): FrameworkThunk {
    return (dispatch, _getState) => {
        dispatch({ type: 'Framework/SET_PREVIEW_FLAG', payload: inp } as unknown as ActionFramework);
    };
}

export function addLogEntry(action: string, screen: string, details: string): FrameworkThunk {
    return async (dispatch, getState) => {
        const logId = getState().Specs.specs?.logId;
        const profile = getState().Framework.specProfile;
        const previewFlag = getState().Framework.previewFlag;
        const custUserId = getState().Appointment.ApptCust.custNameId;
        const custLastName = getState().Appointment.ApptCust.custLastName;
        const custFirstName = getState().Appointment.ApptCust.custFirstName;
        const custEmail = getState().Appointment.ApptCust.custEmailAddress;
        const addlTrackToken = getState().Framework.addlTrackToken;
        const vehVin = getState().Appointment.ApptVeh.vin;
        const vehYear = getState().Appointment.ApptVeh.vehYr;
        const vehMake = getState().Appointment.ApptVeh.make;
        const vehModel = getState().Appointment.ApptVeh.model;
        // const vehSeries = getState().Appointment.ApptVeh.series.replace(/'/g, '&quot') ?? '';
        const vehSeries = getState().Appointment.ApptVeh.series ? getState().Appointment.ApptVeh.series.replace(/'/g, '&quot') : '';
        const vehMileage = getState().Appointment.ApptVeh.mileage;
        const vehColor = getState().Appointment.ApptVeh.vehColor;
        const appt = getState().Framework.loadAppt;
        const ro = getState().Framework.loadRO;
        const opCode = getState().Framework.loadOpCode;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const sessionGUID = getState().Framework.sessionId;
        const eventLogDate = new Date().toJSON();
        let callingProgram = 'SVP';
        const viewMode = getState().Framework.viewMode;
        if (viewMode === ViewMode.ServiceDocs || viewMode === ViewMode.ViewServiceHist) {
            callingProgram = 'OSD';
        }
        const reqData = {
            logId: logId,
            profile: profile,
            previewFlag: previewFlag,
            custUserID: custUserId,
            custLastName: custLastName,
            custFirstName: custFirstName,
            custEmail: custEmail,
            addlTrackToken: addlTrackToken,
            vehVin: vehVin,
            vehYear: vehYear,
            vehMake: vehMake,
            vehModel: vehModel,
            vehSeries: vehSeries,
            vehMileage: vehMileage,
            vehColor: vehColor,
            appt: appt,
            ro: ro,
            opCode: opCode,
            eventLogAction: action,
            eventLogDate: eventLogDate,
            eventLogScreen: screen,
            eventLogDetails: details,
            callingProgram: callingProgram,
            sessionGUID: sessionGUID,
        };
        await acBase.eraWebServiceCall('SVPController', 'AddLogEntry', reqData, store, branch);
        dispatch({
            type: 'Framework/ADD_LOG_ENTRY',
        });
    };
}

export function getAddlTrackCustomerInfo(token: string): FrameworkThunk {
    return async (dispatch, getState) => {
        const logId = getState().Specs.specs?.logId;
        const reqData = {
            keyToken: token,
            callingProgram: 'SVP',
            logId: logId,
        };
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const fordFlag = getState().Specs.specs?.fordSmarttFlag;
        const kiaFlag = getState().Specs.specs?.kiaTrackingFlag;
        let brandRetrieveInfo = '';
        if (fordFlag) {
            brandRetrieveInfo = 'RetrieveFordCustomerInfo';
        }
        if (kiaFlag) {
            brandRetrieveInfo = 'RetrieveKiaCustomerInfo';
        }

        const response = await acBase.eraWebServiceCall('SVPController', brandRetrieveInfo, reqData, store, branch);
        if (response.errMsg === '8000') {
            const frameWorkState = {error: response.errMsg};
            dispatch({
                type: 'Framework/GET_ADDL_TRACK_CUSTOMER_INFO',
                payload: frameWorkState as IFrameworkState,
            });
        } else {
            dispatch({
                type: 'Framework/GET_ADDL_TRACK_CUSTOMER_INFO',
                payload: response as IFrameworkState,
            });
        }
    };
}


export function SetAddlTrackData(token: string, vin: string, year: string, make: string, model: string) {
    return (dispatch) => {
        const data = {
            addlTrackToken: '',
            addlTrackVin: '',
            addlTrackYear: '',
            addlTrackMake: '',
            addlTrackModel: '',
        };
        data.addlTrackToken = token;
        data.addlTrackVin = vin;
        data.addlTrackYear = year;
        data.addlTrackMake = make;
        data.addlTrackModel = model;
        dispatch({
            type: 'Framework/SET_ADDL_TRACK_DATA',
            payload: data,
        });
    };
}

export function ClearAddlTrackCustInfo() {
    return (dispatch) => {
        dispatch({
            type: 'Framework/CLEAR_ADDL_TRACK_CUST_INFO',
        });
    };
}

export function ClearTokenData() {
    return (dispatch) => {
        dispatch({
            type: 'Framework/CLEAR_TOKEN_DATA',
        });
    };
}

export function generateUrl(tokenData: TokenKeys) {
    return async (dispatch, getState) => {
        const logId = getState().Framework.logId;
        let callingProgram = 'SVP';
        const viewMode = getState().Framework.viewMode;
        if (viewMode === ViewMode.ServiceDocs || viewMode === ViewMode.ViewServiceHist) {
            callingProgram = 'OSD';
        }
        const reqData = {
            ...blankToken,
            ...tokenData,
            logId: logId,
            callingProgram: callingProgram,
        };
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const response = await acBase.eraWebServiceCall('SVPController', 'GenerateUrl', reqData, store, branch);
        dispatch({
            type: 'Framework/GENERATE_URL',
            payload: response.url,
        });
    };
}

export function generateDocsUrl(tokenData: TokenKeys) {
    return async (dispatch, getState) => {
        const logId = getState().Framework.logId;
        let callingProgram = 'SVP';
        const viewMode = getState().Framework.viewMode;
        if (viewMode === ViewMode.ServiceDocs || viewMode === ViewMode.ViewServiceHist) {
            callingProgram = 'OSD';
        }
        const reqData = {
            ...blankToken,
            ...tokenData,
            logId: logId,
            callingProgram: callingProgram,
        };
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const response = await acBase.eraWebServiceCall('SVPController', 'GenerateDocsUrl', reqData, store, branch);
        if (response.error === '8000') {
            dispatch({
                type: 'Framework/GET_TOKEN_DATA',
                payload: response as IFrameworkState,
            });
        } else {
            dispatch({
                type: 'Framework/GENERATE_DOCS_URL',
                payload: response.url,
            });
        }
    };
}

export function clearNewTabUrl() {
    return (dispatch) => {
        dispatch({
            type: 'Framework/CLEAR_NEW_TAB_URL',
            payload: '',
        });
    };
}

export function SetToyLexStart(inp: boolean) {
    return (dispatch) => {
        // const data = getState().Framework;
        const data = {
            toyLexStartSent: inp,
        };
        dispatch({
            type: 'Framework/SET_TOYLEX_START',
            payload: data,
        });
    };
}

export function SetToyLexLogin(inp: boolean) {
    return (dispatch) => {
        // const data = getState().Framework;
        const data = {
            toyLexLoginSent: inp,
        };
        dispatch({
            type: 'Framework/SET_TOYLEX_LOGIN',
            payload: data.toyLexLoginSent,
        });
    };
}

export function SetToyLexAccCrt(inp: boolean) {
    return (dispatch) => {
        // const data = getState().Framework;
        const data = {
            toyLexAccCrtSent: inp,
        };
        dispatch({
            type: 'Framework/SET_TOYLEX_ACCT_CREATE',
            payload: data.toyLexAccCrtSent,
        });
    };
}

export function SetWaitOnRecall(value: boolean) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_WAIT_ON_RECALL',
            payload: value,
        });
    };
}

export function SetNoAutoRecall(value: boolean) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_NO_AUTO_RECALL',
            payload: value,
        });
    };
}

export function SetERAError(inp: string) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/ERA_ERROR',
            payload: inp,
        });
    };
}

// Value returns D for desktop or return M for mobile
// This is meant for logging reports
export function SetDesktopOrMobile(value: string) {
    return async (dispatch, getState) => {
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const desktopOrMobile = value;
        const logId = getState().Framework.logId;
        let callingProgram = 'SVP';
        const viewMode = getState().Framework.viewMode;
        if (viewMode === ViewMode.ServiceDocs || viewMode === ViewMode.ViewServiceHist) {
            callingProgram = 'OSD';
        }
        const reqData = {
            logId: logId,
            desktopOrMobile: desktopOrMobile,
            callingProgram: callingProgram,
        };
        await acBase.eraWebServiceCall('SVPController', 'SetDesktopOrMobile', reqData, store, branch);
        dispatch({
            type: 'Framework/SET_DESKTOP_OR_MOBILE',
            payload: value,
        });
    };
}

// Previous token is used to store the user's previous token cookie when doing special token actions such as changing a password.
export function SetPreviousToken(value: string) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_PREVIOUS_TOKEN',
            payload: value,
        });
    };
}

export function SetProfileOpen(value: boolean) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_PROFILE_OPEN',
            payload: value,
        });
    };
}

export function FindIDMdocs(store: string, branch: string, docType: string, key1: string,
    key1value: string, key2: string, key2value: string): FrameworkThunk {
    return async (dispatch, getState) => {
        const docToken = getState().Specs.serviceDocsSpecs?.docToken ?? '';
        // const response = await acBase.eraIDMQueyr('01', '"SERVC01"', '"VCR-OSD"', 'vin', 'JM3KE2DY7F0502932', 'ro', '1234784');
        const response = await acBase.eraIDMQueyr(docToken, store, branch, docType, key1, key1value, key2, key2value);
        dispatch({
            type: 'Framework/FIND_IDM_DOCS',
            payload: response,
        });
    };
}

export function GetIDMdoc(docUUID: string, elementUUID: string): FrameworkThunk {
    return async (dispatch, getState) => {
        const docToken = getState().Specs.serviceDocsSpecs?.docToken ?? '';
        const response = await acBase.getIDMDoc(docToken, docUUID, elementUUID);
        dispatch({
            type: 'Framework/GET_IDM_DOC',
            payload: response,
        });
    };
}

export function GetIDMdocs(idmPdfUUIDs: IdmUuids[]): FrameworkThunk {
    return async (dispatch, getState) => {
        const docToken = getState().Specs.serviceDocsSpecs?.docToken ?? '';

        const urlPromises = idmPdfUUIDs.map(async u => await acBase.getIDMDoc(docToken, u.docUuid, u.elementUuid));

        const urls : string[] = [];

        for await (const url of urlPromises) {
            urls.push(url);
        }

        dispatch({
            type: 'Framework/GET_IDM_DOCS',
            payload: urls,
        });
    };
}

export function ClearIdmFile(): FrameworkThunk {
    return (dispatch) => {
        dispatch({
            type: 'Framework/CLEAR_IDM_FILE',
            payload: '',
        });
    };
}

export function AddCUC(cucNum: number): FrameworkThunk {
    return async (dispatch, getState) => {
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const logId = getState().Framework.logId;
        let callingProgram = 'SVP';
        const viewMode = getState().Framework.viewMode;
        if (viewMode === ViewMode.ServiceDocs || viewMode === ViewMode.ViewServiceHist) {
            callingProgram = 'OSD';
        }
        const reqData = {
            cucNum: cucNum,
            logId: logId,
            callingProgram: callingProgram,
        };
        await acBase.eraWebServiceCall('SVPController', 'AddCUC', reqData, store, branch);
        dispatch({
            type: 'Framework/ADD_CUC',
        });
    };
}

export function SetWaitOnMC(value: boolean) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_WAIT_ON_MC',
            payload: value,
        });
    };
}

export function ViewVehicles(inp: Vehicles): FrameworkThunk {
    return (dispatch, _getState) => {
        dispatch({
            type: 'Framework/VIEW_VEHICLES',
            payload: inp,
        });
    };
}

export function SetVinDialogOpen(inp: boolean) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_VIN_DIALOG_OPEN',
            payload: inp,
        });
    };
}

export function SetVehSelReset(inp: boolean) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_VEHSEL_RESET',
            payload: inp,
        });
    };
}

export function SetIdkMileage(inp: string) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_IDK_MILEAGE',
            payload: inp,
        });
    };
}

export function SetVwDeepLinkMileage(inp: string) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_VW_DEEP_LINK_MILEAGE',
            payload: inp,
        });
    };
}

export function SetVwDeepLinkTrackData(variant: string, provider: string, keyword: string) {
    return (dispatch) => {
        const data = {
            vwVariant: '',
            vwProvider: '',
            vwKeyword: '',
        };
        data.vwVariant = variant;
        data.vwProvider = provider;
        data.vwKeyword = keyword;

        dispatch({
            type: 'Framework/SET_VW_DEEP_LINK_TRACK_DATA',
            payload: data,
        });
    };
}

export function SetAddVehicle(inp: boolean) {
    return (dispatch) => {
        dispatch({
            type: 'Framework/SET_ADD_VEHICLE',
            payload: inp,
        });
    };
}